export default __webpack_public_path__ + "static/Benefits-Before-After-a40da19380218425a2f67fc2f69d1e0b.webp";